import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {reactive, ref} from "vue";
import {LeaderboardMember} from "@/types/LeaderboardMember";
import {ReactiveVariable} from "vue/macros";
import {UpdateBalanceForm} from "@/types/UpdateBalanceForm";
import {useRoute} from "vue-router";
import config from "@/config.json";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateBalance',
  props: {
    member: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute()
let dialog = ref(false)
let valid = ref(true)
let loading = ref(false)
let updateBalance: ReactiveVariable<UpdateBalanceForm> = reactive({balance: props.member.balance, resetXP: false})

const rules = [
  (value: number) => (!isNaN(value) && !(value % 1)) || i18n.global.t('LeaderboardMember.errors.invalidBalance')
]

async function submit() {
  loading.value = true;
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/balances/${props.member.user.id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token') as string
    },
    body: JSON.stringify({
      balance: updateBalance.balance,
      resetXP: updateBalance.resetXP
    })
  })
  if(response.ok) {
    dialog.value = false;
    emit('update', updateBalance)
  }
  loading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_btn, {
      icon: "",
      variant: "text",
      size: "40",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = true : dialog = true))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [
            _createTextVNode("edit")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(dialog),
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : dialog = $event)),
      width: "500px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { color: "modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(props.member.user.username), 1),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = false : dialog = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _unref(valid),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(updateBalance).balance,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(updateBalance).balance) = $event)),
                      class: "ma-0 pa-0",
                      color: "primary",
                      label: _ctx.$t('LeaderboardMember.balance'),
                      rules: rules,
                      "hide-details": "auto"
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_v_checkbox, {
                      modelValue: _unref(updateBalance).resetXP,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(updateBalance).resetXP) = $event)),
                      label: _ctx.$t('LeaderboardMember.resetXP'),
                      color: "primary",
                      "hide-details": ""
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "blue-grey",
                  text: "",
                  loading: _unref(loading),
                  disabled: _unref(valid) === false,
                  onClick: submit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('LeaderboardMember.submit')), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})